import CircularProgress from "@material-ui/core/CircularProgress";
import FormHelperText from "@material-ui/core/FormHelperText";
import _ from "lodash";
import React, {useCallback, useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {toast} from "react-toastify";
import {AnforderungenTabComponent} from "../../components/betriebsakte/bescheid/AnforderungenTabComponent";
import {filteredAnforderungen} from "../../components/betriebsakte/bescheid/utils/bescheidUtils";
import VorbescheidAnforderungenAuswahlDlg from "../../components/betriebsakte/bescheid/VorbescheidAnforderungenAuswahlDlg";
import EABetriebsakteDatenContainer from "../../components/betriebsakte/EABetriebsakteDatenContainer";
import EABetriebsakteMainContainer from "../../components/betriebsakte/EABetriebsakteMainContainer";
import {confirmDeleteOption} from "../../components/ConfirmationDialog/confirmationDialogOptions";
import {useConfirmation} from "../../components/ConfirmationDialog/ConfirmationDialogProvider";
import EAButton from "../../components/EAButton";
import EAButtonBar from "../../components/EAButtonBar";
import EATabs from "../../components/EATabs";
import EATableActionButton from "../../components/tableComponents/EATableActionButton";
import {
    ANFORDERUNGART_BEHOERDLICHE_FESTLEGUNG,
    ANFORDERUNGART_SELBSTUEBERWACHUNGSAUFLAGE,
    anforderungsartIdToObj,
} from "../../consts/anforderungart";
import {PARAMETERART_FRACHT, PARAMETERART_KONZENTRATION, PARAMETERART_MENGE} from "../../consts/anforderungParameterart";
import {BESCHEID_ANGELEGT, BESCHEID_FREIGEGEBEN} from "../../consts/bescheidsstatus";
import {
    BEAUFTRAGTER,
    BETREIBER,
    FACHADMIN,
    LESER_BEHOERDE,
    LESER_ORGANISATION,
    SYSTEMADMIN,
    ZUST_SBB,
} from "../../consts/funktionaleRollen";
import {
    buildDefaultBehoerdlicheFestlegungColumns,
    buildDefaultSelbstueberwachungsColumns,
    createBehoerdlicheFestlegungSchema,
    createInitialAnforderung,
    createSelstuebwerwachungSchema,
} from "../../initialObjects/BescheidObjects";
import {
    deleteMessstelleFromBescheidEndpoint,
    getBescheidEndpoint,
    getBescheidsAnforderungenEndpoint,
    patchBescheidsanforderungenEndpoint,
} from "../../services/BescheidsService";
import {
    getAnforderungEinheitenEndpoint,
    getAnforderungHaeufigkeitenEndpoint,
    getAnforderungProbenahmenEndpoint,
    getAnforderungRandbedingungenEndpoint,
    getAnforderungsparameterEndpoint,
    getAnforderungVorbehandlungenEndpoint,
    getAnforderungWertEndpoint, getSelbstueberwachungVorlagenEndpoint,
} from "../../services/WertelistenService";
import {handleApiException, isApiCancel, useHttp} from "../../services/HttpService";
import {getMessstelleEndpoint} from "../../services/Messstellenservice";
import {createComponentColumn} from "../../utils/ColumnUtils";
import {formatDate} from "../../utils/DateUtils";
import {changeFieldValueIfPresent} from "../../utils/ObjectUtils";
import {userHasAnyRole} from "../../utils/SecurityUtils";
import {NUMBER} from "../../utils/URLUtils";
import usePathParam from "../../utils/usePathParam";
import {usePreformattedHttp} from "../../utils/usePreformattedHttp";

const festlegungenTab = "Festlegungen";
const selbstueberwachungsTab = "Selbstüberwachung";

export function AnforderungenView({betriebstyp, modus, setToggleAllowed, reloadNavigation}) {
    const confirm = useConfirmation();
    const [selectedTab, setSelectedTab] = useState(festlegungenTab);
    const [vorbescheidAuswahlDlgOpen, setVorbescheidAuswahlDlgOpen] = useState(false);
    const history = useHistory();
    const location = useLocation();

    const bescheidsId = usePathParam("bescheidsid", NUMBER);
    const messstellenId = usePathParam("messstellenid", NUMBER);
    const [{data: bescheid, loading: bescheidLoading}] = useHttp(getBescheidEndpoint(bescheidsId), {manual: !bescheidsId});
    const [{data: messstelle, loading: messstelleLoading}] = useHttp(getMessstelleEndpoint(messstellenId), {manual: !messstellenId});
    const [{loading: deleteMessstelleLoading}, deleteMessstelle] = useHttp(
        {
            url: deleteMessstelleFromBescheidEndpoint(bescheidsId, messstellenId),
            method: "DELETE",
        },
        {manual: true}
    );

    const parameterMapper = (data) =>
        data.map((o) => {
            return {id: o.parameterNr, value: o.parameterName};
        });

    const [konzentrationParameter] = usePreformattedHttp(
        parameterMapper,
        getAnforderungsparameterEndpoint(betriebstyp.id, PARAMETERART_KONZENTRATION)
    );
    const [frachtParameter] = usePreformattedHttp(
        parameterMapper,
        getAnforderungsparameterEndpoint(betriebstyp.id, PARAMETERART_FRACHT)
    );
    const [mengeParameter] = usePreformattedHttp(
        parameterMapper,
        getAnforderungsparameterEndpoint(betriebstyp.id, PARAMETERART_MENGE)
    );
    const [konzentrationEinheiten] = useHttp(getAnforderungEinheitenEndpoint(betriebstyp.id, PARAMETERART_KONZENTRATION));
    const [frachtEinheiten] = useHttp(getAnforderungEinheitenEndpoint(betriebstyp.id, PARAMETERART_FRACHT));
    const [mengeEinheiten] = useHttp(getAnforderungEinheitenEndpoint(betriebstyp.id, PARAMETERART_MENGE));
    const [anforderungsWertArten] = useHttp(getAnforderungWertEndpoint);
    const [konzentrationProbenahmen] = useHttp(getAnforderungProbenahmenEndpoint(betriebstyp.id, PARAMETERART_KONZENTRATION));
    const [frachtProbenahmen] = useHttp(getAnforderungProbenahmenEndpoint(betriebstyp.id, PARAMETERART_FRACHT));
    const [mengeProbenahmen] = useHttp(getAnforderungProbenahmenEndpoint(betriebstyp.id, PARAMETERART_MENGE));
    const [probenvorbehandlungen] = useHttp(getAnforderungVorbehandlungenEndpoint);
    const [randbedingungen] = useHttp(getAnforderungRandbedingungenEndpoint);
    const [haeufigkeiten] = useHttp(getAnforderungHaeufigkeitenEndpoint(betriebstyp.id));
    const [selbstueberwachungVorlagen] = useHttp(getSelbstueberwachungVorlagenEndpoint());

    const [{data: persistentAnforderungen, loading: anforderungenLoading}, refetchAnforderungen] = useHttp(
        getBescheidsAnforderungenEndpoint(bescheidsId, messstellenId),
        {
            manual: !bescheidsId || !messstellenId,
        }
    );
    const [{loading: submitLoading, error: submitError}, submit] = useHttp(
        {
            url: patchBescheidsanforderungenEndpoint(bescheidsId, messstellenId),
            method: "PATCH",
        },
        {manual: true}
    );
    const [festlegungen, setFestlegungen] = useState({});
    const [ueberwachungen, setUeberwachungen] = useState({});

    useEffect(() => {
        if (persistentAnforderungen) {
            setFestlegungen(filteredAnforderungen(persistentAnforderungen, ANFORDERUNGART_BEHOERDLICHE_FESTLEGUNG));
            setUeberwachungen(filteredAnforderungen(persistentAnforderungen, ANFORDERUNGART_SELBSTUEBERWACHUNGSAUFLAGE));
        }
    }, [persistentAnforderungen]);

    useEffect(() => {
        if (modus === "s" &&
            bescheid?.bescheidsstatus &&
            ((userHasAnyRole([ZUST_SBB]) && bescheid?.bescheidsstatus?.id === BESCHEID_ANGELEGT) ||
                bescheid?.bescheidsstatus?.id === BESCHEID_FREIGEGEBEN ||
                (userHasAnyRole([BETREIBER, BEAUFTRAGTER]) && bescheid?.bescheidsstatus?.id !== BESCHEID_ANGELEGT) ||
                userHasAnyRole(LESER_BEHOERDE, LESER_ORGANISATION))) {
            history.replace(location.pathname + "?modus=l");
        }
    }, [modus, bescheid, history, location]);

    useEffect(() => {
        if (bescheid?.bescheidsstatus?.id === BESCHEID_FREIGEGEBEN) {
            setToggleAllowed(false);
        } else if (userHasAnyRole([ZUST_SBB]) && bescheid?.bescheidsstatus?.id !== BESCHEID_ANGELEGT) {
            setToggleAllowed(true);
        } else if (userHasAnyRole([BETREIBER, BEAUFTRAGTER]) && bescheid?.bescheidsstatus?.id === BESCHEID_ANGELEGT) {
            setToggleAllowed(true);
        } else if (userHasAnyRole([SYSTEMADMIN, FACHADMIN])) {
            setToggleAllowed(true);
        } else {
            setToggleAllowed(false);
        }
    }, [bescheid, setToggleAllowed]);

    function getListForParameterArt(parameterart, konzentrationsList, frachtList, mengeList) {
        switch (parameterart) {
            case PARAMETERART_KONZENTRATION:
                return konzentrationsList;
            case PARAMETERART_FRACHT:
                return frachtList;
            case PARAMETERART_MENGE:
                return mengeList;
            default:
                return {};
        }
    }

    const getParameterForParameterArt = useCallback(
        (parameterart) => {
            return getListForParameterArt(parameterart, konzentrationParameter, frachtParameter, mengeParameter);
        },
        [konzentrationParameter, frachtParameter, mengeParameter]
    );

    const getEinheitenForParameterArt = useCallback(
        (parameterart) => {
            return getListForParameterArt(parameterart, konzentrationEinheiten, frachtEinheiten, mengeEinheiten);
        },
        [konzentrationEinheiten, frachtEinheiten, mengeEinheiten]
    );

    const getProbenahmenForParameterArt = useCallback(
        (parameterart) => {
            return getListForParameterArt(parameterart, konzentrationProbenahmen, frachtProbenahmen, mengeProbenahmen);
        },
        [konzentrationProbenahmen, frachtProbenahmen, mengeProbenahmen]
    );

    function handleAuswahlAusVorbescheidenConfirm(datum, auswahl) {
        const itemsToAdd = _.cloneDeep(auswahl).map((item) => {
            delete item.id;
            delete item.bescheid;
            item.gueltigAb = datum;
            item.gueltigBis = bescheid.gueltigBis ? bescheid.gueltigBis : new Date("3000-01-01");
            item.messstelle = {id: messstellenId};
            return item;
        });
        setFestlegungen((prevState) => {
            return filteredAnforderungen([...combinedAnforderungen(prevState), ...itemsToAdd], ANFORDERUNGART_BEHOERDLICHE_FESTLEGUNG);
        });
        setUeberwachungen((prevState) => {
            return filteredAnforderungen([...combinedAnforderungen(prevState), ...itemsToAdd], ANFORDERUNGART_SELBSTUEBERWACHUNGSAUFLAGE);
        });
        setVorbescheidAuswahlDlgOpen(false);
    }

    const combinedAnforderungen = (anforderungen) => {
        return [...anforderungen[PARAMETERART_KONZENTRATION], ...anforderungen[PARAMETERART_FRACHT], ...anforderungen[PARAMETERART_MENGE]];
    };

    function toLeseModus() {
        const hasModus = location.search.indexOf("modus") > -1;
        if (modus === "s") {
            history.push(location.pathname + (hasModus ? _.replace(location.search, "modus=s", "modus=l") : "?modus=l"));
        } else {
            history.push(location.pathname + (hasModus ? _.replace(location.search, "modus=l", "modus=s") : "?modus=s"));
        }
    }

    function handleSave() {
        const newAnforderungen = _.cloneDeep([...combinedAnforderungen(festlegungen), ...combinedAnforderungen(ueberwachungen)]);
        console.log("NewAnforderung", newAnforderungen);
        newAnforderungen.forEach((a) => {
            changeFieldValueIfPresent(a, "parameterNr", "id");
            changeFieldValueIfPresent(a, "anforderungArt", "id");
            changeFieldValueIfPresent(a, "messstelle", "id");
            changeFieldValueIfPresent(a, "artAnforderungWert", "id");
            changeFieldValueIfPresent(a, "parameterArt", "id");
            changeFieldValueIfPresent(a, "einheit", "id");
            changeFieldValueIfPresent(a, "einheitAbfluss", "id");
            changeFieldValueIfPresent(a, "einheitKonz", "id");
            changeFieldValueIfPresent(a, "vorlageMesswerte", "id");
            changeFieldValueIfPresent(a, "probenahme", "id");
            changeFieldValueIfPresent(a, "randbedingung", "id");
            changeFieldValueIfPresent(a, "vorbehandlung", "id");
            changeFieldValueIfPresent(a, "haeufigkeit", "id");
        });
        submit({data: newAnforderungen})
            .then(() => {
                refetchAnforderungen().catch((e) => handleApiException(e, "Error loading Anforderungen for Messstelle in Bescheid"));
                toast.success("Die Anforderungen wurden erfolgreich gespeichert");
                toLeseModus();
            })
            .catch((ex) => {
                if (isApiCancel(ex)) {
                    return;
                }
                if (ex.response?.data?.validationErrors) {
                    const errorMessage = Object.values(ex.response.data.validationErrors)[0];
                    toast.warn("Validierung fehlgeschlagen: " + errorMessage);
                } else {
                    handleApiException(ex, "Error saving Anforderungen for Messstelle in Bescheid");
                }
            });
    }

    function handleDelete() {
        confirm(
            confirmDeleteOption("die Messstelle und alle zugehörigen Anforderungen", () =>
                deleteMessstelle()
                    .then(() => {
                        history.replace(
                            history.location.pathname.replaceAll(/messstellen\/.*/g, "bescheiddaten?modus=l")
                        );
                        reloadNavigation();
                        toast.success("Die Messstelle wurde erfolgreich aus dem Bescheid entfernt.");
                    })
                    .catch((e) => handleApiException(e))
            )
        );
    }

    if (anforderungenLoading || deleteMessstelleLoading || bescheidLoading || messstelleLoading || submitLoading) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CircularProgress/>
            </div>
        );
    }
    return (
        <EABetriebsakteMainContainer>
            {vorbescheidAuswahlDlgOpen && (
                <VorbescheidAnforderungenAuswahlDlg
                    onClose={() => setVorbescheidAuswahlDlgOpen(false)}
                    messstellenId={messstellenId}
                    onAuswahlAusVorbescheidenConfirm={handleAuswahlAusVorbescheidenConfirm}
                    bescheid={bescheid}
                />
            )}
            <h3 style={{margin: "var(--vertical-spacing) var(--horizontal-spacing) 0"}}>
                Bescheid: {formatDate(bescheid?.bescheidsdatum)} ({bescheid?.aktenzeichen})
            </h3>
            <h4 style={{margin: "0 var(--horizontal-spacing)"}}>Messstelle: {messstelle?.bezeichnung}</h4>
            <EATabs value={selectedTab} onChange={setSelectedTab} options={[festlegungenTab, selbstueberwachungsTab]}/>
            <EABetriebsakteDatenContainer>
                {selectedTab === festlegungenTab && (
                    <AnforderungenTabComponent
                        anforderungen={festlegungen}
                        modus={modus}
                        setAnforderungen={setFestlegungen}
                        initialAnforderung={createInitialAnforderung(
                            ANFORDERUNGART_BEHOERDLICHE_FESTLEGUNG,
                            messstellenId,
                            bescheid?.bescheidsdatum,
                            bescheid?.ablaufdatum
                        )}
                        anforderungArt={anforderungsartIdToObj(ANFORDERUNGART_BEHOERDLICHE_FESTLEGUNG).value}
                        buildDlgContent={(formFactory, parameterart) => {
                            return buildBehoerdlicheFestlegungContent(
                                formFactory,
                                getParameterForParameterArt(parameterart),
                                getEinheitenForParameterArt(parameterart),
                                getProbenahmenForParameterArt(parameterart),
                                probenvorbehandlungen,
                                randbedingungen,
                                anforderungsWertArten
                            );
                        }}
                        createColumns={(handleDlgOpen) => buildBehoerdlicheFestlegungColumns(handleDlgOpen, modus)}
                        schema={createBehoerdlicheFestlegungSchema()}
                        loading={anforderungenLoading || bescheidLoading}
                    />
                )}
                {selectedTab === selbstueberwachungsTab && (
                    <AnforderungenTabComponent
                        anforderungen={ueberwachungen}
                        modus={modus}
                        setAnforderungen={setUeberwachungen}
                        initialAnforderung={createInitialAnforderung(
                            ANFORDERUNGART_SELBSTUEBERWACHUNGSAUFLAGE,
                            messstellenId,
                            bescheid?.bescheidsdatum,
                            bescheid?.ablaufdatum
                        )}
                        anforderungArt={anforderungsartIdToObj(ANFORDERUNGART_SELBSTUEBERWACHUNGSAUFLAGE).value}
                        buildDlgContent={(formFactory, parameterart) =>
                            buildSelbstueberwachungContent(
                                formFactory,
                                getParameterForParameterArt(parameterart),
                                getProbenahmenForParameterArt(parameterart),
                                haeufigkeiten,
                                getEinheitenForParameterArt(parameterart),
                                selbstueberwachungVorlagen
                            )
                        }
                        createColumns={(handleDlgOpen) => buildSelbstueberwachungsColumns(handleDlgOpen, modus)}
                        schema={createSelstuebwerwachungSchema()}
                        loading={anforderungenLoading || bescheidLoading}
                    />
                )}
                {submitError?.response?.data?.validationErrors && (
                    <FormHelperText className="spacing" id="anforderungenError" data-cy="anforderungenError" error>
                        {Object.values(submitError.response.data.validationErrors).join("\n")}
                    </FormHelperText>
                )}
            </EABetriebsakteDatenContainer>
            {modus === "s" && (
                <EAButtonBar style={{margin: "var(--buttonBar-spacing-top) var(--horizontal-spacing) var(--vertical-spacing)"}}>
                    <EAButton
                        id="messstelleLoeschen"
                        label="Messstelle aus Bescheid löschen"
                        onClick={handleDelete}
                        style={{marginRight: "auto"}}
                    />
                    <EAButton
                        id="ausVorbescheidenAuswaehlen"
                        label="Aus Vorbescheiden auswählen..."
                        onClick={() => setVorbescheidAuswahlDlgOpen(true)}
                    />
                    <EAButton id="submitAnforderungen" loading={submitLoading} label="Speichern" color="primary" onClick={handleSave}/>
                </EAButtonBar>
            )}
        </EABetriebsakteMainContainer>
    );
}

function buildBehoerdlicheFestlegungContent(
    formFactory,
    parameter,
    einheiten,
    probenahmen,
    probenvorbehandlungen,
    randbedingungen,
    anforderungsWertArten
) {
    return (
        <div className="gridl" style={{gridTemplateColumns: "1fr 1fr"}}>
            {formFactory.renderAutocomplete(
                "parameterNr",
                "parameterNr",
                "Parameter",
                parameter.data,
                (o) => o.id + ", " + o.value,
                "id",
                parameter.loading,
                false,
                false,
                {
                    style: {gridColumn: "span 2"},
                }
            )}
            {formFactory.renderNumberInput("wert", "wert", "Wert")}
            {formFactory.renderAutocompleteWerteliste("einheit", "einheit", "Einheit", einheiten)}
            {formFactory.renderAutocompleteWerteliste(
                "artAnforderungWert",
                "artAnforderungWert",
                "Art",
                anforderungsWertArten,
                false,
                false,
                {
                    style: {gridColumn: "span 2"},
                }
            )}
            {
                formFactory.renderAutocompleteWerteliste(
                    "probenahme",
                    "probenahme",
                    "Probenahme",
                    probenahmen,
                    false,
                    false,
                    {
                        style: {gridColumn: "span 2"},
                    },
                    null,
                    false
                )
            }
            {formFactory.renderAutocompleteWerteliste(
                "vorbehandlung",
                "vorbehandlung",
                "Probenvorbehandlung",
                probenvorbehandlungen,
                false,
                false,
                {
                    style: {gridColumn: "span 2"},
                }
            )}
            {formFactory.renderAutocompleteWerteliste("randbedingung", "randbedingung", "Randbedingung", randbedingungen, false, false, {
                style: {gridColumn: "span 2"},
            })}
            {formFactory.renderDatePicker("gueltigAb", "gueltigAb", "Gültig ab")}
            {formFactory.renderDatePicker("gueltigBis", "gueltigBis", "Gültig bis")}
            {formFactory.renderInput("zusatztext", "zusatztext", "Zusatztext", "text", false, {
                style: {gridColumn: "span 2"},
                inputProps: {maxLength: 100},
                multiline: true,
                rows: 4,
            })}
        </div>
    );
}


function buildSelbstueberwachungContent(formFactory, parameter, probenahmen, haeufigkeiten, einheiten, vorlageMesswerte) {
    return (
        <div className="gridl" style={{gridTemplateColumns: "1fr 1fr"}}>
            {formFactory.renderAutocomplete(
                "parameterNr",
                "parameterNr",
                "Parameter",
                parameter.data,
                (o) => o.id + ", " + o.value,
                "id",
                parameter.loading,
                false,
                false,
                {
                    style: {gridColumn: "span 2"},
                }
            )}
            {formFactory.renderAutocompleteWerteliste("probenahme", "probenahme", "Probenahme", probenahmen, false, false, {
                style: {gridColumn: "span 2"},
            })}
            {formFactory.renderAutocompleteWerteliste("haeufigkeit", "haeufigkeit", "Häufigkeit", haeufigkeiten, false, false, {
                style: {gridColumn: "span 2"},
            })}
            {formFactory.renderAutocompleteWerteliste("einheit", "einheit", "Einheit", einheiten, false, false, {
                style: {gridColumn: "span 2"}
            })}
            {formFactory.renderAutocompleteWerteliste("einheitAbfluss", "einheitAbfluss", "Einheit Wassermenge (Frachtberechnung)", einheiten, false, false, {
                style: {gridColumn: "span 2"},
            })}
            {formFactory.renderAutocompleteWerteliste("einheitKonz", "einheitKonz", "Einheit Konz. (Frachtberechnung)", einheiten, false, false, {
                style: {gridColumn: "span 2"},
            })}
            {formFactory.renderAutocompleteWerteliste("vorlageMesswerte", "vorlageMesswerte", "Vorlage Messwerte", vorlageMesswerte, false, false, {
                style: {gridColumn: "span 2"},
            })}
            {formFactory.renderDatePicker("gueltigAb", "gueltigAb", "Gültig ab")}
            {formFactory.renderDatePicker("gueltigBis", "gueltigBis", "Gültig bis")}
            {formFactory.renderInput("zusatztext", "zusatztext", "Zusatztext", "text", false, {
                style: {gridColumn: "span 2"},
                inputProps: {maxLength: 100},
                multiline: true,
                rows: 4,
            })}
        </div>
    );
}

const buildInnerColumns = (handleDlgOpen, modus) => createComponentColumn(
    "actions",
    (row, index) => {
        return (
            <div className="eatabwrapper">
                {modus === "s" && (
                    <EATableActionButton id={"abs-" + index} iconName="ico-edit">
                        <span onClick={() => handleDlgOpen(row, index)}/>
                    </EATableActionButton>
                )}
                <EATableActionButton id={"abl-" + index} iconName="ico-view">
                    <span onClick={() => handleDlgOpen(row, index, true)}/>
                </EATableActionButton>
            </div>
        );
    },
    "",
    null,
    {padding: 0, width: "50px", minWidth: "50px", maxWidth: "50px"}
);

const buildBehoerdlicheFestlegungColumns = (handleDlgOpen, modus) => [
    buildInnerColumns(handleDlgOpen, modus),
    ...buildDefaultBehoerdlicheFestlegungColumns(),
];

const buildSelbstueberwachungsColumns = (handleDlgOpen, modus) => [
    buildInnerColumns(handleDlgOpen, modus),
    ...buildDefaultSelbstueberwachungsColumns(),
];
